import * as React from "react";
import {Button} from "@progress/kendo-react-buttons";
import {Input} from "@progress/kendo-react-inputs";
import {subscriptionUserAPI} from "../../../../../../utilities/api";
import {confirmPasswordValidator, emailValidator, passwordValidator} from "../../../helpers/Validators";
import {Field, FieldWrapper, Form, FormElement} from "@progress/kendo-react-form";
import {isNullOrEmptyString} from "@progress/kendo-data-query/dist/npm/utils";
import PasswordForm from "../../../helpers/PasswordForm";

export const RegisterSteps = () => {
    const [step, setStep] = React.useState<number>(0);
    const [error, setError] = React.useState<string>("");

    const handleSubmit = async (dataItem: { [name: string]: any }) => {
        localStorage.setItem("subscriptionEmail", dataItem.email);

        await subscriptionUserAPI.createLoginSubscriptionUser(dataItem.email, dataItem.password, dataItem.confirm_password)
            .then( () => {
                setStep(1);
                setError("");
            }).catch( (error) => {
                setError(error.response.data.message);
            });
    };

    return (
        <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
            { !isNullOrEmptyString(error) &&<p style={{color: "red"}}>{error}</p>}

            {step === 0 ?
                <Form
                    onSubmit={handleSubmit}
                    render={() => (
                        <FormElement>
                            <div style={{alignSelf: "center"}}>
                                <div style={{color: "#3271E7", width: "30vw"}}>
                                    <FieldWrapper>
                                        <PasswordForm />

                                        <Field name={"email"} component={Input} labelclassname={"k-form-label"}
                                               label={"Email Address"} validator={emailValidator}/>
                                        <Field name={"password"} component={Input} labelclassname={"k-form-label"}
                                               label={"Password"} type={"password"} validator={passwordValidator}/>
                                        <Field name={"confirm_password"} component={Input} labelclassname={"k-form-label"}
                                               label={"Confirm Password"} type={"password"} validator={confirmPasswordValidator}/>
                                    </FieldWrapper>

                                    <div style={{justifyContent: "space-between", alignContent: "center", marginTop: "20px"}}
                                         className={"k-form-buttons k-button k-button-md k-rounded-md k-button-solid k-button-solid-bases-end"}><div>
                                        <Button themeColor={"primary"} type={"submit"}>Submit</Button>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </FormElement>
                    )}
                />
                :
                <div>
                    <h2>Check Your Email for the Activation Link</h2>
                </div>
            }
        </div>
    );
};
